<template>
  <div v-if="isDisplay" class="wrap_a2hs" @click="del"><img src="/assets/img/common/img_a2hs.png" alt="ホーム画面に追加するとアプリとしてご利用できます。"></div>
</template>

<script>
export default {
  name: 'A2HS',
  data () {
    return {
      isDisplay: true
    }
  },
  computed: {
    isStandAlone () {
      return navigator.standalone
    },
    isAppleMobile () {
      return /iPhone|iPad/.test(navigator.userAgent)
    }
  },
  methods: {
    del () {
      this.$el.classList.add('delete')
    }
  },
  mounted () {
    if (localStorage.getItem('bunnerCount') == null) {
      localStorage.setItem('bunnerCount', 0)
    }
    const count = Number(localStorage.getItem('bunnerCount'));
    this.isDisplay = count < 5 && this.isAppleMobile && !this.isStandAlone
    localStorage.setItem('bunnerCount', count + 1)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap_a2hs {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 1000;
  max-width: 320px;
  margin-left: -160px;
  &.delete {
    display: none;
  }
}

</style>
